import * as Sentry from "@sentry/browser";
import env from "../env";
import { isBlockingAds } from "./block-detection";
import { uuidv4 } from "./random";

async function retireLocal() {
  // Intentionally a bit opaque
  const stateKey = 'g8-th';

  try {
    localStorage.removeItem(stateKey);
  } catch (error) {
    // ssh
  }
}

async function fetchWithTimeout(resource: RequestInfo, options: RequestInit) {
  const timeout = 10 * 1000;
  const controller = new AbortController();
  const id = setTimeout(() => controller.abort(), timeout);

  const response = await fetch(resource, {
    ...options,
    signal: controller.signal
  });

  clearTimeout(id);

  return response;
}

export default async function throttle(id: string, idType: string): Promise<boolean> {
  retireLocal();

  const params = new URLSearchParams({
    reqId: uuidv4(),
    type: idType,
    adblocking: isBlockingAds() ? '1' : '0',
  });

  try {
    const req = await fetchWithTimeout(`${env.apiUrl}/analytics/impressions/${id}?${params.toString()}`, {
      method: 'POST',
      body: '{}',
      cache: 'no-cache',
      credentials: 'omit',
    });

    return req.status !== 204;
  } catch (err) {
    Sentry.captureException(err);
    return false;
  }
}
